import API, { type ApiOptions } from '@/api/base';

const Master = {
  // マスタ情報一覧取得
  getMasterList: async () => {
    const options: ApiOptions = {
      method: 'GET',
      url: `new_eve/game/get_data_master`
    };
    return await API.request(options);
  }
};

export default Master;
